import React, { Component } from "react";
import ReactDOM from "react-dom";

export default function EmailToBook(props) {
  return (
    <button
      className="btn btn-rounded btn-primary py-3 px-5 mb-3"
      style={{ cursor: "pointer" }}
      data-target="#email-book-modal"
      data-toggle="modal"
    >
      {/* <i className="fa fa-2x fas fa-envelope body-text-color"></i> */}
      <span className="font-weight-bold">{props.active_site.domain == 'www.islandroutes.com' ? 'Contact a Concierge' : 'Book by Email'}</span>
    </button>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/EmailToBook.js